// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IReferralItem {
  /** Имя реферала **/
  name: string;
  /** Телефон реферала **/
  phone: string;
  /** Статус реферала **/
  status: EStatus;
  /** Дата обновления **/
  date: string;
}

export enum EStatus {
  /** Деньги получены **/
  'Paid' = 'paid',
  /** Сделка завершилась **/
  'Completed' = 'completed',
  /** Отказ от программы **/
  'Rejected' = 'rejected',
  /** В программе **/
  'InProgram' = 'inProgram',
}
